export default __webpack_public_path__ + "static/media/89t.b246081b.jpg";